<template>
	<div>
		<div class="boxerp">
			<el-image style="width: 100%;" :src="bannerList[0].bannerUrlPc"
					  fit="contain" v-if="bannerList.length==1" @click.stop="gotoLink(bannerList[0])"></el-image>
		  <el-carousel trigger="click" :autoplay="false" :height="swiperHeight" v-else>
			<el-carousel-item v-for="(item, index) in bannerList" :key="index">
			  <div class="banner-img flexcenter" @click.stop="gotoLink(item)">
				<el-image style="height: 100%;" :src="item.bannerUrlPc"
					fit="cover"></el-image>
			  </div>
			</el-carousel-item>
		  </el-carousel>
		</div>
		<div class="boxphone">
			<el-image style="width: 100%;height: 720px;" :src="bannerList[0].bannerUrlWeb"
					  fit="cover" v-if="bannerList.length==1" @click.stop="gotoLink(bannerList[0])"></el-image>
			<van-swipe class="my-swipe" v-else :autoplay="3000" indicator-color="white">
				<van-swipe-item v-for="(item, index) in bannerList" :key="index">
					<div class="tacenter" style="height: 100%;" @click.stop="gotoLink(item)">
						<el-image style="height: 100%;" :src="item.bannerUrlWeb"
							fit="cover"></el-image>
					</div>
				</van-swipe-item>
			</van-swipe>
		</div>
	</div>
</template>
<script>
  export default {
      data() {
        return {
          bannerHeight: '10rem',
          swiperHeight: '980px',
        };
      },
      props: {
		  windowWidth: {
          type: Number,
          default: 1200
        },
        bannerList: {
          type: Array,
          default: []
        }
      },
      created() {

      },
      mounted(){
        },
      methods: {
        handleClick(tab, event) {
          // console.log(tab._props.name, event);
          this.$emit('handleClick', tab._props.name)
        },
        gotoLink(item){
          console.log('点击了banner')
          if(item.linkUrl){
            console.log('item.linkUrl', item.linkUrl)
            window.open(item.linkUrl, "_blank");
          }
        },
      }
    };
</script>

<style scoped lang="less">
	@media screen and (max-width: 480px){
		.boxerp{display: none;}
		.boxphone{height: 720px;}
		.boxphone{
			::v-deep .van-swipe__track{align-items: center;}
			::v-deep .van-swipe{height: 100%;}
		}
	}
	@media screen and (min-width: 481px){
		.boxerp{width: 100%;margin: 0 auto;}
		.boxphone{display: none;}
	}
  .banner-img{height: 100%;}

</style>
